import {useContext} from 'react'
import {CustomerRepReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {CUSTOMER_REP_REPORT_COLUMNS} from '../../utils'
import CustomerRepReportRow from './CustomerRepReportRow'
import {parseCustomerRepReportRow} from '../../parsings'
import {formatPrice} from '../../../../utils/common'

const CustomerRepReportTable = () => {
  const {reportData, isLoading, onSortingChange, filters} = useContext(CustomerRepReportContext)

  return (
    <DynamicTable
      data={reportData}
      sortableColumns={CUSTOMER_REP_REPORT_COLUMNS}
      loading={isLoading}
      TableRow={CustomerRepReportRow}
      noDataMessage='No customer rep reports found'
      onSortingChange={onSortingChange}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
      rowParsingFunction={parseCustomerRepReportRow}
      filters={filters}
      tableFooter={({columnTotals}: any) => (
        <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
          <tr>
            <td colSpan={2}>TOTAL</td>
            <td>{columnTotals?.total_orders}</td>
            <td>{columnTotals?.profitable_orders}</td>
            <td>{columnTotals?.non_profitable_orders}</td>
            <td>{formatPrice(columnTotals.total_cost, false)}</td>
            <td>{formatPrice(columnTotals.total_sales, false)}</td>
            <td></td>
            <td>{formatPrice(columnTotals.total_profit, false)}</td>
          </tr>
        </tfoot>
      )}
    />
  )
}

export default CustomerRepReportTable
